import Modal from "../../../../components/modal"
import PlayerCard from "../GridPlayers/components/PlayerCard"
import "./index.css"

const ConfirmVoteModal = ({player, vote, cancel})=>{
    return(<Modal>
        <div className="confirm-modal-container">
                    <div className="confirm-modal-card-container" >
        <p className="confirm-modal-card-title">¿Seguro que quieres votar por este jugador?</p>
        <PlayerCard handleVoteByPlayer={vote} player={player}  />
        <div className="confirm-modal-card-container-buttons">
            <button className="btn-confirm" onClick={()=>vote(player)}>Confirmar</button>
            <button className="btn-cancel" onClick={cancel}>Cancelar</button>
        </div>

        </div>

        </div>
    </Modal>)
}

export default ConfirmVoteModal